module.exports = __webpack_public_path__ + "static/img/equation.d0a208d7.png";